import styled from 'styled-components';
import { Colors } from 'basic-ui-lib';
// import { IcDraft, IcPublish, IcClose, IcPause, IcPlay } from 'basic-ui-lib/icons';
import DeviceHeader from '../DeviceHeader';
import ConnectedTimeCard from '../ConnectedTimeCard';
import DeviceInfoList from '../DeviceInfoList';
import { IDevice } from 'modules/dashboard/interfaces/api';
import { ScreenStatus } from 'modules/dashboard/services/constants';

interface DevicePanelProps {
  isCreateMode?: boolean;
  screenId?: string;
  screenStatus?: ScreenStatus | null;
  deviceInfo?: IDevice | null;
  isLoading?: boolean;
  onSaveDraft?: () => void;
  onPublish?: () => void;
  onDeactivate?: () => void;
  onPause?: () => void;
  onReactivate?: () => void;
}

const DevicePanel = ({ 
  isCreateMode = true,
  screenId,
  screenStatus,
  deviceInfo,
  // isLoading,
  // onSaveDraft,
  // onPublish,
  // onDeactivate,
  // onPause,
  // onReactivate,
}: DevicePanelProps) => {
  
  // const renderButtons = () => {
  //   if (isCreateMode) {
  //     return (
  //       <ButtonGroup>
  //         <Button 
  //           type_light 
  //           lg 
  //           onClick={onSaveDraft} 
  //           style={{ flex: 1 }} 
  //           prefix={<IcDraft width={16} height={16} fill={Colors.neutral.text[3]} />}
  //         >
  //           Draft
  //         </Button>
  //         <Button 
  //           type_second 
  //           lg 
  //           onClick={onPublish} 
  //           style={{ flex: 1 }} 
  //           prefix={<IcPublish width={16} height={16} fill={Colors.neutral.bg[1]} />}
  //         >
  //           Publish
  //         </Button>
  //       </ButtonGroup>
  //     );
  //   }

  //   switch (screenStatus) {
  //     case 'DRAFT':
  //       return (
  //         <ButtonGroup>
  //           <Button 
  //             type_second 
  //             lg 
  //             onClick={onPublish} 
  //             style={{ flex: 1 }} 
  //             prefix={<IcPublish width={16} height={16} fill={Colors.neutral.bg[1]} />}
  //           >
  //             Publish
  //           </Button>
  //         </ButtonGroup>
  //       );

  //     case 'ONLINE':
  //       return (
  //         <ButtonGroup>
  //           <StyledButton 
  //             type_light 
  //             lg 
  //             onClick={onDeactivate} 
  //             prefix={<IcClose width={16} height={16} fill={Colors.neutral.text[3]} />}
  //           >
  //             Deactivate
  //           </StyledButton>
  //           <StyledButton 
  //             type_red 
  //             lg 
  //             onClick={onPause} 
  //             prefix={<IcPause width={16} height={16} fill={Colors.neutral.text[1]} />}
  //           >
  //             Pause
  //           </StyledButton>
  //         </ButtonGroup>
  //       );

  //     case 'OFFLINE':
  //       return (
  //         <ButtonGroup>
  //           <Button 
  //             type_light 
  //             lg 
  //             onClick={onDeactivate} 
  //             style={{ flex: 1 }} 
  //             prefix={<IcClose width={16} height={16} fill={Colors.neutral.text[3]} />}
  //           >
  //             Deactivate
  //           </Button>
  //         </ButtonGroup>
  //       );

  //     case 'DEACTIVATED':
  //       return (
  //         <ButtonGroup>
  //           <Button 
  //             type_second 
  //             lg 
  //             onClick={onReactivate} 
  //             style={{ flex: 1 }} 
  //             prefix={<IcPlay width={16} height={16} fill={Colors.neutral.bg[1]} />}
  //           >
  //             Reactivate
  //           </Button>
  //         </ButtonGroup>
  //       );

  //     default:
  //       return null;
  //   }
  // };
  
  return (
    <Container>
      <ContentWrapper>
        <DeviceHeader deviceInfo={deviceInfo} screenStatus={screenStatus ?? undefined} isCreateMode={isCreateMode} />
        <ConnectedTimeCard />
        <DeviceInfoList deviceInfo={deviceInfo} screenId={screenId} isCreateMode={isCreateMode} />
      </ContentWrapper>

      {/* <ButtonSection>
        <Divider />
        {!isLoading && renderButtons()}
      </ButtonSection> */}
    </Container>
  );
};

export default DevicePanel;

const Container = styled.div`
  width: 301px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: ${Colors.neutral.bg[1]};
  border-left: 1px solid ${Colors.neutral.border[1]};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  flex: 1;
`;

// const ButtonSection = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// const Divider = styled.div`
//   height: 1px;
//   background: ${Colors.neutral.border[1]};
// `;

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 8px;
//   padding: 16px;
// `;

// const StyledButton = styled(Button)`
//   flex: 1;
//   min-width: 0;
// `;
